import { createAsyncThunk } from "@reduxjs/toolkit";
import { postUpdateProfilePassword } from "../../helpers/fakebackend_helper";

export const profile_update_passwordThunk = createAsyncThunk(
  "profile_update_passwordThunk",
  async ({ params, token }, { rejectWithValue }) => {
    try {
      const response = await postUpdateProfilePassword(params, token);
      return response;
    } catch (error) {
      return rejectWithValue(
        error || {
          message: "Something went wrong",
        }
      );
    }
  }
);
